/* Test de Finanzas NDF — versión vanilla JS (sin dependencias) */
(function () {
  "use strict";

  var PET = '#022332';
  var CREAM = '#FBF8F3';

  // ---- VSL: video real con controles propios (sin pausa, sin adelantar) ----
  // Pega acá la URL del video una vez que esté grabado y subido (a un host que
  // sirva el archivo directo, ej. un .mp4 en Shopify Files, Vimeo con link directo,
  // o similar). Mientras esto esté vacío, se muestra un cuadro de reemplazo y el
  // diagnóstico se desbloquea solo, después de unos segundos, para poder seguir
  // revisando el resto de la página sin tener que esperar el video real.
  var VSL_VIDEO_URL = '';
  var VSL_UNLOCK_SECONDS = 210; // 3:30 — momento real del video en que se revela el diagnóstico
  var VSL_FALLBACK_DURATION = '7:40'; // duración conocida del guion, se usa hasta que cargue el video real

  // ---- Klaviyo: registro del diagnóstico (correo + base de leads) ----
  // Se usa la "Client Events API" pública de Klaviyo — está hecha para llamarse
  // desde el navegador, así que no expone ninguna llave privada. KLAVIYO_COMPANY_ID
  // es tu "Public API Key", no tu llave secreta: la encuentras en Klaviyo →
  // Settings (ícono de engranaje) → API Keys → "Public API Key" (6 caracteres).
  var KLAVIYO_COMPANY_ID = 'QPR54y';
  var KLAVIYO_METRIC_NAME = 'Diagnostico de finanzas completado';

  var STAGE_META = {
    explorando: { name: 'explorando', color: '#7ED957', blurb: 'estás armando la base. las próximas preguntas son sobre la plata que todavía no has puesto — y la que no deberías perder.' },
    iniciando: { name: 'iniciando', color: '#E8762C', blurb: 'ya vendes. ahora hay que ver si esas ventas te dejan algo. las próximas preguntas van por ahí.' },
    caos: { name: 'gobernando el caos', color: '#e7392f', blurb: 'vendes seguido y la operación pesa. las próximas preguntas son sobre gobernar los números, no solo revisarlos.' },
    escalando: { name: 'escalando', color: '#4884a3', blurb: 'ya no apagas incendios. las próximas preguntas son sobre capital, caja y decisiones de crecimiento.' }
  };
  var LETTER_STAGE = { a: 'explorando', b: 'iniciando', c: 'caos', d: 'escalando' };

  var SEG = [
    { text: '¿cómo describirías tu ecommerce hoy?', options: [
      'todavía no vendo, estoy viendo qué y a quién vender',
      'ya vendo, pero peleo por que las ventas sean recurrentes',
      'vendo seguido, pero la operación me tiene comido',
      'vendo bien y ya no apago incendios todo el día — el tema es crecer'] },
    { text: '¿cuál es tu facturación mensual aproximada?', options: [
      'aún no facturo, o facturo menos de 1 millón al mes',
      'entre 1 y 15 millones al mes',
      'entre 15 y 50 millones al mes',
      'más de 50 millones al mes'] },
    { text: '¿cuántas personas están metidas en el día a día del negocio?', options: [
      'solo yo', '1 a 3 apoyándome', 'equipo armado (4+)'] }
  ];

  function q(text, a, b, c) { return { type: 'q', text: text, options: [a, b, c] }; }
  function inter(quote, note, kicker, source) { return { type: 'inter', quote: quote, note: note, kicker: kicker, source: source }; }

  var BLOCKS = {
    explorando: [
      q('¿tienes calculado cuánto necesitas para partir — inventario inicial, plataforma, primeros ads?',
        'sí, tengo el número y de dónde va a salir', 'tengo una idea aproximada, nada escrito', 'no, voy viendo en el camino'),
      q('¿ya tienes costo de tu producto y precio de venta definidos, con margen calculado entre los dos?',
        'sí, y sé cuánto me deja cada venta', 'tengo precio, el margen nunca lo calculé bien', 'puse el precio mirando a la competencia'),
      q('¿sabes cuántas unidades necesitas vender para recuperar tu inversión inicial?',
        'sí, tengo el número claro', 'lo he pensado, pero no lo he calculado', 'no tengo idea'),
      inter('una fundadora de la comunidad que estaba por lanzar su marca decidió vender por preventa antes de fabricar todo el stock — así no comprometía plata que no tenía.',
        'meter toda la inversión antes de validar que la gente compra es el error más caro de esta etapa.', 'de la comunidad'),
      q('si el negocio no genera plata los primeros meses, ¿cuánto tiempo puedes sostenerte tú — no el negocio, tú — sin esa plata?',
        'más de 6 meses, ya lo tengo cubierto', 'dos o tres meses', 'no lo he pensado — necesito que rinda ya'),
      q('¿vas a separar la plata del negocio de la tuya desde el primer peso que entre?',
        'sí, cuenta aparte desde el día uno', 'lo voy a hacer, pero todavía no', 'no, va a ser todo la misma cuenta')
    ],
    iniciando: [
      q('cuando alguien te pregunta cómo van los números de tu negocio, ¿qué respondes?',
        'sé exactamente si gano o pierdo plata', 'más o menos sé, pero no podría explicarlo con números', 'eso lo ve mi contador'),
      q('¿la plata del negocio y la tuya viven en la misma cuenta?',
        'no, están separadas y me pago un sueldo', 'están separadas, pero me paso plata cuando necesito', 'sí, es la misma cuenta'),
      q('¿sabes cuánto te deja cada pedido después de descontar la publicidad?',
        'sí, lo tengo por producto', 'sé el promedio, sin detalle', 'no lo he calculado'),
      inter('"ganar plata no es igual a ser rentable."', 'las próximas preguntas son para ver de qué lado estás tú.', 'oscar rincón · zerda finance'),
      q('¿tienes calculado tu punto de equilibrio — cuánto necesitas vender al mes para no perder plata?',
        'sí, y lo reviso cada mes', 'lo calculé una vez, hace tiempo', 'no sé cuál es'),
      q('¿entiendes por qué a veces tu banco dice una cosa y tus ventas dicen otra?',
        'sí, caja y utilidad no son lo mismo', 'algo entiendo, pero me confunde', 'no, y me tiene mareado'),
      inter('una dueña de ecommerce de mascotas que está en la comunidad subió sus precios en mercado libre para no seguir perdiendo plata — pensó que las ventas se le iban a caer. no pasó nada.',
        'a veces el miedo al precio es más caro que el precio.', 'de la comunidad'),
      q('cuando bajas precios o haces una promo, ¿calculas antes el impacto en tu margen?',
        'sí, calculo el impacto antes de publicarla', 'a veces, si me acuerdo', 'no, primero vendo y después veo'),
      q('¿sabes cuántos meses aguanta tu negocio con la caja que tienes hoy si las ventas se detuvieran mañana?',
        'sí, sé cuántos meses aguanto', 'creo que un par de meses', 'nunca lo he mirado'),
      inter('4 de cada 10 emprendimientos en chile no llegan a su tercer año — y los errores financieros son la causa más repetida.',
        'no es mala suerte. es no mirar los números a tiempo.', 'dato real · chile', 'Fuente: Portal Innova, 2025')
    ],
    caos: [
      q('¿revisas tu estado de resultados (P&L) todos los meses, o solo cuando algo se siente raro?',
        'todos los meses, con fecha fija', 'cada cierto tiempo, cuando puedo', 'solo cuando algo se siente raro'),
      q('¿sabes si tu margen bruto viene subiendo, bajando o estancado mes a mes — o solo miras el mes actual?',
        'veo la tendencia mes a mes', 'comparo con el mes anterior nomás', 'solo miro el mes actual'),
      q('¿te ha pasado que el papel dice utilidad pero la caja no refleja esa plata? si te ha pasado, ¿sabes por qué?',
        'me ha pasado y sé exactamente por qué', 'me ha pasado y no sé por qué', 'nunca lo he revisado'),
      inter('"¿estamos ganando dinero de verdad, o solo facturando?"', 'eso es exactamente lo que miden las próximas preguntas.'),
      q('¿sabes cuál es el producto que más vende versus el que más margen realmente te deja?',
        'sí, tengo margen por producto', 'sé cuál vende más, del margen no estoy seguro', 'no lo tengo separado'),
      q('cuando planificas ventas del mes, ¿comparas después lo real contra lo proyectado?',
        'sí, todos los meses', 'de vez en cuando', 'no proyecto'),
      inter('"no mueres por no vender, mueres por no tener caja."', 'la que sigue es sobre tomar esa decisión antes de que la caja te obligue a tomarla.', 'oscar rincón'),
      q('si tuvieras que cortar un costo fijo o pausar un canal mañana porque el margen no da, ¿sabrías cuál mover primero?',
        'sí, sé exactamente cuál movería primero', 'tendría que sentarme a mirarlo', 'no sabría por dónde partir'),
      inter('el ecommerce en chile movió cerca de US$10.000 millones en 2025 — un 9% más que el año anterior.',
        'el mercado crece. la pregunta es si tu margen crece con él, o si solo estás facturando más para ganar lo mismo.',
        'dato real · chile 2025', 'Fuente: Cámara de Comercio de Santiago, 2025')
    ],
    escalando: [
      inter('"cómo gobernar tu negocio, no solo operarlo."', 'esa es la etapa en la que estás tú ahora — las siguientes preguntas son sobre eso.', 'de la masterclass de indicadores · oscar rincón, zerda finance'),
      q('¿sabes qué canal o línea de tu negocio realmente te deja más plata, no solo más ventas?',
        'sí, tengo margen por canal y por línea', 'sé cuál vende más, no cuál deja más', 'lo veo todo junto'),
      q('cuando el negocio genera utilidad, ¿tienes un criterio claro de cuánto reinviertes y cuánto retiras?',
        'sí, tengo una regla definida', 'depende del mes', 'retiro cuando hay'),
      q('¿proyectas tu caja a 12 meses, o solo miras los próximos 30-60 días?',
        'sí, proyección a 12 meses que actualizo', 'proyecto un trimestre', 'solo los próximos 30-60 días'),
      q('¿sabes cuánto capital necesitas para tu próximo salto de crecimiento?',
        'sí, tengo el monto y de dónde sale', 'una idea gruesa', 'no lo he calculado'),
      q('¿tu equipo de confianza revisa los números contigo, o los ves solo tú?',
        'sí, hay una revisión periódica con el equipo', 'comparto algunos números', 'los veo solo yo')
    ]
  };

  var TIERS = {
    rojo: { label: 'riesgo alto', color: '#e7392f' },
    amarillo: { label: 'brechas críticas', color: '#E8B62C' },
    verde: { label: 'bases sólidas', color: '#7ED957' }
  };

  var DIAG_LONG = {
    explorando: {
      rojo: [
        'estás en la etapa más honesta de todas — la de partir — y ahí normalmente el número no manda, mandan las ganas. el problema es que las ganas no pagan el arriendo de la bodega ni la boleta de meta ads. hoy no tienes calculado cuánto necesitas para partir, ni el margen entre lo que te cuesta tu producto y lo que lo vendes, ni cuántas unidades necesitas mover para recuperar lo que ya pusiste. eso significa que estás corriendo con los ojos cerrados justo en la etapa donde más se necesita tenerlos abiertos — la plata inicial es la única que no se recupera dos veces.',
        'hay algo que sí tienes claro: sabes que este negocio no puede vivir mezclado con tu billetera personal — y ese es justo el hábito que más gente rompe demasiado tarde. partir con esa separación ya te pone un paso adelante de founders que llevan años sin lograrlo.',
        'lo que falta es aterrizar los tres números que sostienen cualquier partida: cuánto necesitas para partir, cuánto te deja cada venta después del costo real, y cuántas unidades te separan de dejar de poner plata de tu bolsillo. sin esos tres, cada decisión que tomes de acá en adelante es una apuesta — y las apuestas, en esta etapa, se pagan caro.'
      ],
      amarillo: [
        'ya tienes algunas cuentas claras, pero todavía hay zonas grises que te pueden salir caras si no las cierras antes de que el negocio empiece a moverse en serio. no es que estés perdido — es que estás construyendo el avión mientras despegas, y hay piezas que conviene atornillar antes de subir la velocidad.',
        'sabes cuánto necesitas para partir y tienes idea de tu margen entre costo y precio de venta — eso ya te saca del grupo que arranca puramente a la fe. también tienes clara la cantidad de unidades que necesitas para recuperar tu inversión inicial, lo que te da un norte real en vez de una sensación.',
        'el hueco está en lo que viene después de partir: cuánto tiempo puedes sostenerte tú — no el negocio, tú — si las ventas tardan en llegar, y si vas a separar la plata del negocio de la tuya desde el primer peso. son preguntas que no se sienten urgentes hasta el mes en que sí lo son.'
      ],
      verde: [
        'para estar recién partiendo, tienes algo que muy pocos founders en esta etapa tienen: los números básicos ya calculados, no imaginados. eso no te asegura que el negocio va a funcionar — nada lo asegura — pero sí te asegura que si no funciona, vas a saber exactamente por qué, y no por plata mal calculada.',
        'tienes claro cuánto necesitas para partir, el margen real entre costo y precio, cuántas unidades necesitas vender para recuperar tu inversión, y ya decidiste separar la plata del negocio de la tuya desde el primer peso. ese combo, en esta etapa, es más raro de lo que crees.',
        'lo único que te falta afinar es tu propio colchón: cuánto tiempo puedes sostenerte tú, no el negocio, si las ventas tardan más de lo esperado. no es un problema del negocio — es un problema de cuánto margen de error te estás dando a ti como persona. resuélvelo y vas a partir con la cabeza mucho más despejada que la mayoría.'
      ]
    },
    iniciando: {
      rojo: [
        'llevas ventas corriendo, pero todavía no sabes con certeza si tu negocio gana plata o simplemente factura. esa diferencia parece sutil hasta que un mes la caja no cuadra y no tienes cómo explicar por qué. hoy tu cuenta del negocio y la tuya personal viven juntas, no tienes calculado cuánto te deja cada pedido después de la publicidad, ni tu punto de equilibrio — y eso hace que cada decisión de precio o de promo la tomes a ciegas.',
        'algo juega a tu favor: ya tienes ventas recurrentes, que es exactamente lo que la mayoría en esta etapa todavía no logra. el motor funciona — lo que falta es el tablero que te diga si ese motor te está dejando plata o solo dando vueltas.',
        'las tres brechas que más te están costando plata: no saber cuánto te deja cada pedido después de la publicidad, no tener tu punto de equilibrio calculado, y no saber cuántos meses aguanta tu caja si las ventas se detuvieran mañana. son preguntas que casi nadie se hace hasta que ya es tarde — y son justo las que separan un negocio que vende de un negocio que gana.'
      ],
      amarillo: [
        'ya sabes más de tus números que la mayoría en tu etapa, pero todavía hay bloques importantes sin calcular — y esos bloques son justo los que te permiten dejar de reaccionar y empezar a decidir con información real.',
        'sabes si tu negocio gana o pierde plata, en general — no es una intuición, tienes algo de claridad ahí. también entiendes por qué a veces el banco dice una cosa y tus ventas dicen otra, lo que te ahorra sustos que a otros los toman por sorpresa. y antes de bajar un precio o lanzar una promo, calculas el impacto en tu margen — eso, en esta etapa, no es común.',
        'lo que queda pendiente: separar de una vez la plata del negocio de la tuya, calcular tu punto de equilibrio real, y saber cuánto te deja cada pedido después de publicidad. no son ajustes menores — son la diferencia entre administrar un negocio y que el negocio te administre a ti.'
      ],
      verde: [
        'para estar en la etapa de iniciar, tienes un manejo de números que normalmente se ve más adelante. no estás improvisando — estás decidiendo con información, que es exactamente lo que te va a permitir moverte a la siguiente etapa sin arrastrar los mismos problemas de siempre.',
        'sabes si ganas o pierdes plata, tienes tu punto de equilibrio calculado, calculas el impacto en tu margen antes de mover precios, y sabes cuántos meses aguanta tu caja si las ventas se frenaran. ese nivel de control, acá, es la excepción, no la regla.',
        'lo que te falta afinar es más fino que urgente: cuánto te deja cada pedido después de publicidad, con el detalle suficiente para afinarlo canal por canal. no es una alarma, es la siguiente vuelta de tuerca.'
      ]
    },
    caos: {
      rojo: [
        'tu negocio ya mueve plata en serio, pero la información que tienes sobre esa plata no te alcanza para gobernarlo — solo para reaccionar cuando algo truena. hoy no revisas tu estado de resultados con regularidad, no sabes si tu margen bruto viene subiendo o bajando, y cuando el papel dice utilidad pero la caja no refleja esa plata, no tienes claro por qué. eso es operar el negocio a ciegas, con el volumen ya alto.',
        'algo juega a tu favor: el negocio ya genera el volumen suficiente para que estas preguntas importen de verdad — muchos nunca llegan a este punto. tienes la base de ventas; lo que falta es el criterio para leerla.',
        'las brechas más urgentes: no saber cuál es tu producto que más margen te deja versus el que más vende, no comparar lo proyectado contra lo real, y no tener claro qué costo o canal cortarías primero si el margen no da. sin esas respuestas, cada mes administras el caos en vez de administrar el negocio.'
      ],
      amarillo: [
        'ya no estás completamente a ciegas — hay partes de tu negocio que sí estás mirando con criterio — pero todavía hay puntos ciegos que te están costando margen sin que lo notes en el día a día.',
        'revisas tu estado de resultados con cierta regularidad, y cuando planificas ventas del mes, comparas después lo real contra lo proyectado — eso ya te pone por delante de negocios de tu tamaño que siguen improvisando. también tienes una idea de qué producto te deja más margen, aunque no la tengas del todo afinada.',
        'lo que falta cerrar: entender por qué a veces la utilidad en el papel no se refleja en tu caja, saber si tu margen bruto viene subiendo o bajando mes a mes, y tener claro qué costo fijo o canal cortarías primero si el margen no da. son las preguntas que separan gobernar el caos de solo sobrevivirlo.'
      ],
      verde: [
        'tu negocio ya factura fuerte, y a diferencia de la mayoría en esta etapa, tú sí lo estás gobernando — no solo operando. eso no es poco: la mayoría de los negocios de tu tamaño siguen apagando incendios sin mirar el panel completo.',
        'revisas tu p&l con regularidad, sabes si tu margen bruto sube o baja, entiendes por qué a veces la utilidad en papel no calza con la caja, sabes qué producto realmente te deja margen, comparas lo real contra lo proyectado, y tienes claro qué cortarías primero si el margen aprieta. ese nivel de control es exactamente lo que te permite crecer sin que se te caiga la estructura.',
        'el siguiente nivel ya no es sobre entender tus números — es sobre usarlos para decidir hacia dónde reinviertes y hasta dónde puedes estirar la máquina sin romperla. ahí es donde entra la siguiente etapa.'
      ]
    },
    escalando: {
      rojo: [
        'facturas como una empresa grande, pero todavía tomas decisiones grandes con información de negocio chico. no tienes claro qué canal o línea realmente te deja más plata — no solo más ventas —, no proyectas tu caja más allá de 30 o 60 días, y no sabes cuánto capital necesitas para tu próximo salto de crecimiento. a este tamaño, ese nivel de imprecisión no es un detalle, es un riesgo real.',
        'el negocio ya llegó al punto donde estas preguntas son las que importan de verdad — eso, en sí, es un logro que casi nadie de tu tamaño reconoce a tiempo. tienes la escala; ahora falta el criterio a la altura de esa escala.',
        'lo urgente: identificar qué línea de negocio realmente te deja plata, no solo ventas; definir un criterio claro de cuánto reinviertes y cuánto retiras; y proyectar tu caja al menos a 12 meses. sin eso, cada decisión grande que tomes sigue siendo una apuesta con números chicos.'
      ],
      amarillo: [
        'ya tomas decisiones con más criterio que la mayoría de negocios de tu tamaño, pero todavía hay zonas donde decides con el estómago en vez de con el número — y a esta escala, eso se nota rápido en la caja.',
        'tienes claro qué canal o línea realmente te deja más plata, no solo más ventas, y proyectas tu caja más allá del próximo mes. eso ya te separa de negocios que crecen en ventas pero no en criterio.',
        'lo que falta afinar: un criterio claro de cuánto reinviertes y cuánto retiras cuando el negocio genera utilidad, cuánto capital necesitas realmente para tu próximo salto, y si tu equipo de confianza revisa los números contigo o los ves solo tú. a este tamaño, ya no puedes ser el único que mira el tablero.'
      ],
      verde: [
        'tienes el negocio y tienes el criterio — algo que en esta etapa no es tan común como debería. no estás operando el caos, lo estás gobernando con información real, y eso es justo lo que te permite pensar en el próximo salto sin apostar a ciegas.',
        'sabes qué canal o línea te deja más plata de verdad, tienes un criterio claro entre reinvertir y retirar, proyectas tu caja a 12 meses, sabes cuánto capital necesitas para tu próximo salto, y tu equipo de confianza revisa los números contigo. ese nivel de control es exactamente lo que separa una empresa que crece de una que solo se hace más grande.',
        'lo que sigue ya no es un problema de números — es un problema de con quién los conversas. el directorio, formal o informal, es el siguiente paso natural cuando ya nadie puede seguir cargando solo con la mirada completa del negocio.'
      ]
    }
  };

  // Diagnóstico corto (2 párrafos) — se usa en el bloque "diagnóstico corto + recursos"
  // que aparece justo al desbloquear (o de inmediato, para explorando). Es distinto de
  // DIAG_LONG (3 párrafos), que se sigue usando para el correo/Klaviyo.
  var DIAG = {
    explorando: {
      rojo: ['todavía no partes y ya estás en riesgo de partir mal.', 'no tienes el número de cuánto necesitas, ni el margen, ni la separación de la plata. eso no es falta de talento: es falta de números. lo bueno es que todavía no has gastado — que es exactamente el mejor momento para arreglarlo.'],
      amarillo: ['tienes intuición, pero te faltan tres números que cambian todo.', 'sabes por dónde va la cosa, pero hay huecos: margen sin calcular del todo, punto de recuperación estimado a ojo, o tu propia plata mezclada con la del negocio. si partes así, vas a estar operando a ciegas justo cuando cada peso pesa más.'],
      verde: ['partes con la cabeza en el lugar correcto.', 'tienes claro cuánto necesitas, cuánto te deja cada venta y en cuánto recuperas. tu riesgo ya no es financiero, es de validación: que la gente compre. no metas todo el stock antes de probar que compran.']
    },
    iniciando: {
      rojo: ['vendes, pero no sabes si ganas. y eso se paga caro.', 'hoy tu negocio funciona con la plata que entra, no con los números que decides. sin punto de equilibrio, sin margen por pedido y con las cuentas mezcladas, cualquier mes malo te pega directo al bolsillo. hay que ordenar antes de crecer.'],
      amarillo: ['vas bien, pero hay brechas críticas.', 'ya tienes algunas cosas claras y otras a medias — sabes el promedio pero no el detalle, calculaste el punto de equilibrio hace tiempo, la promo la haces primero y la miras después. son brechas chicas hoy y caras cuando subas el volumen.'],
      verde: ['tienes bases sólidas para esta etapa.', 'sabes lo que te deja cada pedido, tienes las cuentas separadas y mides antes de mover precios. tu siguiente frontera no es entender los números: es usarlos para decidir dónde poner la plata en los próximos 12 meses.']
    },
    caos: {
      rojo: ['la operación te está gobernando a ti.', 'facturas bien, pero los números llegan después de las decisiones, no antes. sin p&l mensual y sin margen por producto, estás creciendo sobre una base que no puedes ver. eso es exactamente lo que revienta la caja de negocios que venden mucho.'],
      amarillo: ['tienes control parcial, y el margen se te escapa en las esquinas.', 'revisas cosas, pero no con ritmo ni con comparación. sabes qué vende más, no qué deja más. sin real vs. proyectado, cada mes es una sorpresa nueva. el orden acá no es más trabajo: es un calendario y tres indicadores.'],
      verde: ['estás gobernando el caos, no solo aguantándolo.', 'revisas p&l, ves tendencia y sabes qué mover si el margen aprieta. lo que sigue es dejar de administrar el mes y empezar a proyectar el año: caja a 12 meses y criterio de reinversión.']
    },
    escalando: {
      rojo: ['estás escalando con visibilidad de negocio chico.', 'a tu tamaño, no tener margen por canal ni caja proyectada no es un descuido: es riesgo de capital. cada mes que creces sin esos números, aumentas la apuesta sin saber a qué le estás apostando.'],
      amarillo: ['tienes tamaño, pero el criterio financiero va detrás del crecimiento.', 'algunas cosas están: proyectas, revisas, tienes idea del capital. lo que falta es sistema — margen por línea, regla de retiro/reinversión y un equipo que mire los números contigo. sin eso, el próximo salto depende de tu memoria.'],
      verde: ['tienes el negocio gobernado.', 'margen por canal, caja proyectada, criterio de reinversión y equipo mirando los mismos números. tu siguiente conversación no es de orden, es de estrategia de capital: dónde poner la plata para el próximo salto.']
    }
  };

  var VIDEOS = {
    explorando: [
      { id: 'cpX7jxL9C2o', t: 324, min: '5:24', title: 'Aakash Goklani · Elite Perfumes', quote: '"tenía que ver cómo levantarlo rápidamente y sin capital… me gasté buena parte de lo que tenía ahorrado y tenía como 10.000 u 11.000 dólares."' },
      { id: 'aFuVaYBPzGk', t: 3258, min: '54:18', title: 'Pancho Ordenes', quote: 'un cliente que "pagaron 200 mil dólares por su e-commerce y no guardaron ningún dinero para invertir luego en el lanzamiento."' },
      { id: 'Rl28Aly-Kbc', t: 1671, min: '27:51', title: 'Vale Ahumada', quote: '"paso cero, vender algo decente; paso uno, márgenes: asegurarte un margen que te permita pagar la publicidad."' }
    ],
    iniciando: [
      { id: 'MUpKPjiiBac', t: 1249, min: '20:49', title: 'Mariano Delpech · NDF56', quote: '"un founder que tiene una empresa y no se maneja financieramente, las chances de morir son inminentes."' },
      { id: 'qEkqI2pzni8', t: 311, min: '5:11', title: 'Gianina Rodríguez y Miguel Ángel Soto', quote: 'sistema "margen diario": "este día ganaste 1.100 pesos."' },
      { id: 'ssTu_miJBjE', t: 1668, min: '27:48', title: 'Cómo WINEHOUSE salió de su peor crisis', quote: '"no quiero ver flujo de caja, quiero entender… había que romper el chanchito."' }
    ],
    caos: [
      { id: '_oIK-_41ykU', t: 3827, min: '1:03:47', title: 'Ernesto De Mayo · Zeroq', quote: '"monthly business review": una reunión que dura casi todo el día, con corte mensual sobre el mismo panel de kpis.' },
      { id: 'BVmUng2zAXM', t: 2726, min: '45:26', title: 'Jane Morgan', quote: '"tenemos muchas ventas, pero los costos llegan directamente a la última línea."' },
      { id: '6sMHpPGDoS4', t: 2511, min: '41:51', title: 'Dakota, Eduardo y Fauadz · MyCocos', quote: 'framework "reversible o no reversible": "si es reversible, equivócate mil veces, y ahí vas aprendiendo."' }
    ],
    escalando: [
      { id: '_oIK-_41ykU', t: 3653, min: '1:00:53', title: 'Ernesto De Mayo · Zeroq', quote: 'el capital se destina a capex y casi nunca a opex: "hoy ya estamos con la caja positiva."' },
      { id: 'LwdRJs_BSCE', t: 2103, min: '35:03', title: 'Max Sateler · Reuse', quote: 'perú vs. méxico: "un mercado de 140 millones de habitantes, con infraestructura de primer nivel en e-commerce."' },
      { id: 'KhCgw-gu2bE', t: 833, min: '13:53', title: 'Jose Cofré · Froens', quote: '"ese plan de 5 años es un planillo gigante de sku por sku, mes por mes, porcentaje de crecimiento."' }
    ]
  };

  var state = { screen: 'landing', segIdx: 0, segAnswers: [], stage: null, bIdx: 0, scores: [], sel: null, name: '', email: '', whatsapp: '', unlocked: false, muted: false };
  var vslFallbackTimer = null;
  var vslExpectedTime = 0;

  function tint(hex, alpha) {
    var h = hex.replace('#', '');
    var n = parseInt(h, 16);
    return 'rgba(' + [(n >> 16) & 255, (n >> 8) & 255, n & 255].join(',') + ',' + alpha + ')';
  }

  // Validación del formulario de contacto (nombre/correo/whatsapp) — una sola función,
  // usada tanto al renderizar el botón como al escribir, para que nunca queden
  // desincronizados entre sí (fue justo ese tipo de desincronización la causa del bug
  // del botón que se veía deshabilitado antes).
  function isEmailValid(v) { return /.+@.+\..+/.test(v); }
  function isWhatsappValid(v) { return (v || '').replace(/[^\d]/g, '').length >= 8; }
  function isGateValid() { return isEmailValid(state.email) && isWhatsappValid(state.whatsapp); }

  function stageKey() { return state.stage; }
  function steps() { return BLOCKS[stageKey()] || []; }
  function questionSteps() { return steps().filter(function (s) { return s.type === 'q'; }); }

  function computeStage(answers) {
    var counts = {};
    answers.forEach(function (i) { var l = 'abcd'[i]; counts[l] = (counts[l] || 0) + 1; });
    var max = Math.max.apply(null, Object.keys(counts).map(function (k) { return counts[k]; }));
    if (max === 1) return LETTER_STAGE['abcd'[answers[1]]];
    var winner = Object.keys(counts).filter(function (k) { return counts[k] === max; })[0];
    return LETTER_STAGE[winner] || 'iniciando';
  }

  function tierKey(pct) {
    if (pct < 34) return 'rojo';
    if (pct < 72) return 'amarillo';
    return 'verde';
  }

  function fmt(sec) {
    var m = Math.floor(sec / 60); var s = sec % 60;
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  // ---- transiciones de estado ----

  function advance() {
    var s = state;
    if (s.screen === 'landing') { s.screen = 'notice'; render(); return; }
    if (s.screen === 'notice') { s.screen = 'seg'; s.segIdx = 0; s.sel = null; render(); return; }
    if (s.screen === 'seg') {
      var answers = s.segAnswers.slice(0, s.segIdx).concat([s.sel]);
      if (s.segIdx < 2) { s.segAnswers = answers; s.segIdx += 1; s.sel = null; render(); return; }
      s.segAnswers = answers; s.stage = computeStage(answers); s.screen = 'reveal'; s.sel = null; render(); return;
    }
    if (s.screen === 'reveal') { s.screen = 'block'; s.bIdx = 0; s.scores = []; s.sel = null; render(); return; }
    if (s.screen === 'block') {
      var step = steps()[s.bIdx];
      var scores = step.type === 'q' ? s.scores.concat([[3, 1, 0][s.sel]]) : s.scores;
      if (s.bIdx < steps().length - 1) { s.scores = scores; s.bIdx += 1; s.sel = null; render(); return; }
      s.scores = scores; s.screen = 'gate'; s.sel = null; render(); return;
    }
    if (s.screen === 'gate') {
      sendDiagnosisEmail();
      s.screen = 'result'; s.unlocked = (stageKey() === 'explorando');
      render();
      if (stageKey() !== 'explorando') initVslVideo();
      return;
    }
  }

  function goBack() {
    var s = state;
    if (s.screen === 'seg' && s.segIdx > 0) { s.segIdx -= 1; s.sel = s.segAnswers[s.segIdx]; render(); return; }
    if (s.screen === 'block' && s.bIdx > 0) {
      var prev = steps()[s.bIdx - 1];
      s.scores = prev.type === 'q' ? s.scores.slice(0, -1) : s.scores;
      s.bIdx -= 1; s.sel = null; render(); return;
    }
  }

  function restart() {
    clearTimeout(vslFallbackTimer);
    state = { screen: 'landing', segIdx: 0, segAnswers: [], stage: null, bIdx: 0, scores: [], sel: null, name: '', email: '', whatsapp: '', unlocked: false, muted: false };
    render();
  }

  function sendDiagnosisEmail() {
    if (!KLAVIYO_COMPANY_ID || KLAVIYO_COMPANY_ID === 'TU_PUBLIC_API_KEY_AQUI') {
      console.warn('Klaviyo no está configurado: falta reemplazar KLAVIYO_COMPANY_ID en este archivo.');
      return;
    }

    var stageK = stageKey();
    var meta = STAGE_META[stageK];
    var total = state.scores.reduce(function (a, b) { return a + b; }, 0);
    var maxScore = Math.max(1, questionSteps().length * 3);
    var pct = Math.round((total / maxScore) * 100);
    var tierK = tierKey(pct);
    var diag = (DIAG_LONG[stageK] || DIAG_LONG.iniciando)[tierK];
    var nowIso = new Date().toISOString();

    // Los 3 videos recomendados de esta etapa, para que el correo de Klaviyo pueda
    // mostrarlos sin tener que duplicar la lógica de VIDEOS ahí — se manda ya armado.
    var videosForEmail = (VIDEOS[stageK] || VIDEOS.iniciando).map(function (v) {
      return { title: v.title, quote: v.quote, min: v.min, url: 'https://youtu.be/' + v.id + '?t=' + v.t };
    });

    var eventProperties = {
      etapa: stageK,
      etapa_nombre: meta ? meta.name : '',
      tramo: tierK,
      tramo_label: TIERS[tierK].label,
      puntaje_pct: pct,
      diagnostico_general: diag[0],
      puntos_fuertes: diag[1],
      espacios_mejora: diag[2] || ''
    };
    videosForEmail.forEach(function (v, i) {
      var n = i + 1;
      eventProperties['video_' + n + '_titulo'] = v.title;
      eventProperties['video_' + n + '_cita'] = v.quote;
      eventProperties['video_' + n + '_min'] = v.min;
      eventProperties['video_' + n + '_url'] = v.url;
    });

    var payload = {
      data: {
        type: 'event',
        attributes: {
          properties: eventProperties,
          time: nowIso,
          unique_id: (state.email || 'anon') + '-' + Date.now(),
          metric: {
            data: {
              type: 'metric',
              attributes: { name: KLAVIYO_METRIC_NAME }
            }
          },
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: state.email,
                first_name: state.name,
                phone_number: state.whatsapp,
                properties: {
                  ultimo_diagnostico_etapa: stageK,
                  ultimo_diagnostico_tramo: tierK,
                  ultimo_diagnostico_puntaje_pct: pct,
                  ultimo_diagnostico_fecha: nowIso
                }
              }
            }
          }
        }
      }
    };

    fetch('https://a.klaviyo.com/client/events?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'Revision': '2026-07-15'
      },
      body: JSON.stringify(payload)
    }).catch(function (err) {
      // Si esto falla, la persona igual ve su diagnóstico en pantalla —
      // solo no queda registrado en Klaviyo. Revisa la consola si pasa seguido.
      console.error('No se pudo registrar el diagnóstico en Klaviyo:', err);
    });
  }

  // ---- VSL: video real, sin pausa ni scrub, con desbloqueo real a los 3:30 ----
  //
  // Nada de esto usa un timer inventado: escucha al elemento <video> real. Si todavía
  // no hay video (VSL_VIDEO_URL vacío), cae a un modo de reemplazo que desbloquea solo
  // a los pocos segundos, para poder seguir revisando el resto de la página mientras
  // tanto — ese modo de reemplazo desaparece solo en cuanto pegues la URL real.

  function initVslVideo() {
    if (!VSL_VIDEO_URL) {
      // Modo reemplazo: no hay video real todavía — desbloquea a los 3s para poder
      // seguir probando/revisando el resto del flujo sin tener que esperar.
      clearTimeout(vslFallbackTimer);
      vslFallbackTimer = setTimeout(function () {
        if (!state.unlocked) { state.unlocked = true; onVslUnlock(); }
      }, 3000);
      return;
    }
    var video = document.getElementById('vsl-video');
    if (!video) return;
    vslExpectedTime = 0;

    video.addEventListener('loadedmetadata', function () {
      if (isFinite(video.duration) && video.duration > 0) {
        var remEl = document.getElementById('vsl-remaining');
        if (remEl) remEl.textContent = fmt(Math.round(video.duration));
      }
    });

    video.addEventListener('timeupdate', function () {
      vslExpectedTime = video.currentTime;
      var elapsedEl = document.getElementById('vsl-elapsed');
      var remainingEl = document.getElementById('vsl-remaining');
      var fillEl = document.getElementById('vsl-fill');
      if (elapsedEl) elapsedEl.textContent = fmt(Math.floor(video.currentTime));
      if (isFinite(video.duration) && video.duration > 0) {
        if (remainingEl) remainingEl.textContent = '-' + fmt(Math.max(0, Math.round(video.duration - video.currentTime)));
        if (fillEl) fillEl.style.width = Math.min(100, (video.currentTime / video.duration) * 100) + '%';
      }
      if (!state.unlocked && video.currentTime >= VSL_UNLOCK_SECONDS) {
        state.unlocked = true;
        onVslUnlock();
      }
    });

    // Sin scrub: si el tiempo salta más de lo que explica la reproducción normal
    // (adelantar con el teclado, un doble clic, etc.), lo devolvemos a donde iba.
    video.addEventListener('seeking', function () {
      if (Math.abs(video.currentTime - vslExpectedTime) > 1.5) {
        video.currentTime = vslExpectedTime;
      }
    });

    // Sin pausa: si algo la dispara igual (barra espaciadora, tecla de medios de
    // unos audífonos), retomamos de inmediato.
    video.addEventListener('pause', function () {
      if (!video.ended) video.play().catch(function () {});
    });

    attemptVslAutoplay(video);
  }

  function attemptVslAutoplay(video) {
    video.muted = false;
    var playPromise = video.play();
    if (playPromise && playPromise.catch) {
      playPromise.catch(function () {
        // el navegador bloqueó el audio automático: seguimos en silencio para no
        // perder el avance real del video, y mostramos el botón para activar sonido.
        video.muted = true;
        state.muted = true;
        video.play().catch(function () {});
        var overlay = document.getElementById('vsl-sound-overlay');
        if (overlay) overlay.style.display = 'flex';
      });
    }
  }

  function activarSonidoVsl() {
    var video = document.getElementById('vsl-video');
    var overlay = document.getElementById('vsl-sound-overlay');
    if (video) { video.muted = false; state.muted = false; video.play().catch(function () {}); }
    if (overlay) overlay.style.display = 'none';
    updateVslMuteBtn();
  }

  function toggleVslMute() {
    var video = document.getElementById('vsl-video');
    if (!video) return;
    video.muted = !video.muted;
    state.muted = video.muted;
    updateVslMuteBtn();
  }

  function updateVslMuteBtn() {
    var btn = document.getElementById('vsl-mute-btn');
    if (btn) btn.textContent = state.muted ? 'activar sonido' : 'silenciar';
  }

  function onVslUnlock() {
    var lockedEl = document.getElementById('locked-notice');
    var unlockedEl = document.getElementById('unlocked-wrap');
    if (lockedEl) lockedEl.style.display = 'none';
    if (unlockedEl) unlockedEl.style.display = 'flex';
  }

  // ---- render: cada pantalla devuelve un string de HTML ----

  function renderLanding() {
    return '' +
      '<div style="min-height:100vh; background:#022332; color:#FBF8F3; display:flex; flex-direction:column; align-items:center; padding:72px 24px 88px">' +
        '<div style="width:100%; max-width:820px; display:flex; flex-direction:column; gap:56px">' +
          '<div style="display:flex; flex-direction:column; gap:26px; align-items:flex-start">' +
            '<div style="font-size:12px; font-weight:600; letter-spacing:.16em; text-transform:uppercase; color:rgba(251,248,243,.55)">test de finanzas para dueños de ecommerce · ndf</div>' +
            '<h1 style="margin:0; font-size:64px; line-height:1.02; font-weight:800; letter-spacing:-.03em; text-transform:uppercase; text-wrap:balance">tu ecommerce factura. ¿pero gana?</h1>' +
            '<p style="margin:0; font-size:20px; line-height:1.5; font-weight:400; color:rgba(251,248,243,.72); max-width:34em">son 3 minutos. al final vas a saber exactamente cómo estás parado con la plata de tu negocio.</p>' +
            '<div style="display:flex; flex-direction:column; gap:12px; align-items:flex-start; margin-top:8px">' +
              '<button data-action="advance" class="btn-landing-cta" style="border:0; cursor:pointer; background:#FBF8F3; color:#022332; font-size:17px; font-weight:700; padding:19px 34px; border-radius:6px; letter-spacing:-.01em">empezar el test</button>' +
              '<div style="font-size:13px; color:rgba(251,248,243,.45)">sin power point. solo las preguntas que necesitas hacerte.</div>' +
            '</div>' +
          '</div>' +
          '<div style="height:1px; background:rgba(251,248,243,.14)"></div>' +
          '<div style="display:flex; flex-direction:column; gap:28px">' +
            '<div style="font-size:12px; font-weight:700; letter-spacing:.16em; text-transform:uppercase; color:rgba(251,248,243,.5)">cómo funciona</div>' +
            '<div style="display:grid; grid-template-columns:repeat(3, 1fr); gap:28px">' +
              '<div style="display:flex; flex-direction:column; gap:14px"><div style="font-size:13px; font-weight:700; color:#7ED957">01</div><div style="font-size:16px; line-height:1.5; color:rgba(251,248,243,.85)">respondes preguntas sobre cómo manejas la plata de tu negocio hoy.</div></div>' +
              '<div style="display:flex; flex-direction:column; gap:14px"><div style="font-size:13px; font-weight:700; color:#E8762C">02</div><div style="font-size:16px; line-height:1.5; color:rgba(251,248,243,.85)">te decimos en qué estado está tu relación con las finanzas de tu negocio.</div></div>' +
              '<div style="display:flex; flex-direction:column; gap:14px"><div style="font-size:13px; font-weight:700; color:#4884a3">03</div><div style="font-size:16px; line-height:1.5; color:rgba(251,248,243,.85)">te mostramos cuál es tu siguiente paso — con el mismo criterio que usamos en +100 entrevistas del podcast Negocios del Futuro y en cada diagnóstico 1:1 que hacemos con dueños de ecommerce reales.</div></div>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function renderNotice() {
    return '' +
      '<div style="min-height:100vh; background:#022332; color:#FBF8F3; display:flex; align-items:center; justify-content:center; padding:48px 24px">' +
        '<div style="max-width:560px; display:flex; flex-direction:column; gap:28px" class="ndf-anim">' +
          '<div style="font-size:12px; font-weight:700; letter-spacing:.16em; text-transform:uppercase; color:rgba(251,248,243,.5)">antes de empezar</div>' +
          '<p style="margin:0; font-size:30px; line-height:1.28; font-weight:600; letter-spacing:-.02em">sé fiel a tu realidad — tus respuestas acá condicionan todo el resto del test.</p>' +
          '<button data-action="advance" class="btn-landing-cta" style="align-self:flex-start; border:0; cursor:pointer; background:#FBF8F3; color:#022332; font-size:16px; font-weight:700; padding:17px 30px; border-radius:6px">entendido, vamos</button>' +
        '</div>' +
      '</div>';
  }

  function renderQuestion() {
    var s = state;
    var stageK = stageKey();
    var meta = STAGE_META[stageK];
    var accent = meta ? meta.color : PET;
    var onDark = stageK === 'explorando' || stageK === 'iniciando';
    var btnFg = onDark ? PET : '#fff';
    var inBlock = s.screen === 'block';

    var step, qNumber, qTotal, blockLabel, canGoBack, pickAction;
    if (inBlock) {
      step = steps()[s.bIdx];
      qNumber = steps().slice(0, s.bIdx + 1).filter(function (x) { return x.type === 'q'; }).length;
      qTotal = questionSteps().length;
      blockLabel = meta ? meta.name : '';
      canGoBack = s.bIdx > 0;
      pickAction = 'pick-block';
    } else {
      step = SEG[s.segIdx];
      qNumber = s.segIdx + 1;
      qTotal = 3;
      blockLabel = 'tu punto de partida';
      canGoBack = s.segIdx > 0;
      pickAction = 'pick-seg';
    }

    var optionsHtml = step.options.map(function (text, i) {
      var on = s.sel === i;
      var bg = on ? tint(accent, .1) : '#fff';
      var border = on ? accent : 'rgba(2,35,50,.12)';
      var letterBg = on ? accent : 'rgba(2,35,50,.07)';
      var letterColor = on ? (onDark ? PET : '#fff') : 'rgba(2,35,50,.55)';
      return '' +
        '<button data-action="' + pickAction + '" data-idx="' + i + '" style="display:flex; gap:14px; align-items:flex-start; width:100%; cursor:pointer; background:' + bg + '; border:1.5px solid ' + border + '; border-radius:8px; padding:18px 20px; color:' + PET + '; text-align:left; transition:all .14s ease">' +
          '<span style="flex:0 0 auto; width:24px; height:24px; border-radius:99px; font-size:12px; font-weight:700; display:flex; align-items:center; justify-content:center; background:' + letterBg + '; color:' + letterColor + '">' + 'abcd'[i] + '</span>' +
          '<span style="font-size:17px; line-height:1.4; font-weight:500; text-align:left">' + text + '</span>' +
        '</button>';
    }).join('');

    var nextDisabled = s.sel === null;
    var accentTextColor = accent === '#7ED957' ? '#4f9c31' : accent;

    return '' +
      '<div style="min-height:100vh; background:#FBF8F3; display:flex; flex-direction:column; align-items:center; padding:40px 24px 72px">' +
        '<div style="width:100%; max-width:720px; display:flex; flex-direction:column; gap:40px">' +
          '<div style="display:flex; flex-direction:column; gap:12px">' +
            '<div style="display:flex; justify-content:space-between; align-items:baseline">' +
              '<div style="font-size:12px; font-weight:700; letter-spacing:.14em; text-transform:uppercase; color:rgba(2,35,50,.5)">pregunta ' + qNumber + ' de ' + qTotal + '</div>' +
              '<div style="font-size:12px; font-weight:700; letter-spacing:.14em; text-transform:uppercase; color:' + accentTextColor + '">' + blockLabel + '</div>' +
            '</div>' +
            '<div style="height:4px; border-radius:99px; background:rgba(2,35,50,.1); overflow:hidden">' +
              '<div style="height:100%; width:' + (qTotal ? (qNumber / qTotal * 100) : 0) + '%; background:' + accent + '; border-radius:99px; transition:width .3s ease"></div>' +
            '</div>' +
          '</div>' +
          '<h2 style="margin:0; font-size:34px; line-height:1.22; font-weight:700; letter-spacing:-.025em; text-wrap:pretty">' + step.text + '</h2>' +
          '<div style="display:flex; flex-direction:column; gap:12px">' + optionsHtml + '</div>' +
          '<div style="display:flex; align-items:center; gap:18px">' +
            '<button data-action="advance" ' + (nextDisabled ? 'disabled' : '') + ' style="border:0; cursor:' + (nextDisabled ? 'not-allowed' : 'pointer') + '; background:' + accent + '; color:' + btnFg + '; font-size:16px; font-weight:700; padding:17px 32px; border-radius:6px; opacity:' + (nextDisabled ? '.35' : '1') + '; align-self:flex-start">siguiente</button>' +
            (canGoBack ? '<button data-action="back" class="btn-link-muted" style="border:0; background:none; cursor:pointer; font-size:14px; font-weight:600; color:rgba(2,35,50,.45); padding:8px 0">volver</button>' : '') +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function renderReveal() {
    var stageK = stageKey();
    var meta = STAGE_META[stageK];
    var accent = meta.color;
    var onDark = stageK === 'explorando' || stageK === 'iniciando';
    return '' +
      '<div style="min-height:100vh; background:' + accent + '; color:' + (onDark ? PET : '#FBF8F3') + '; display:flex; align-items:center; justify-content:center; padding:56px 24px">' +
        '<div style="max-width:640px; display:flex; flex-direction:column; gap:24px" class="ndf-anim">' +
          '<div style="font-size:12px; font-weight:700; letter-spacing:.16em; text-transform:uppercase; opacity:.6">tu etapa</div>' +
          '<div style="font-size:60px; line-height:1.02; font-weight:800; letter-spacing:-.035em; text-transform:uppercase">' + meta.name + '</div>' +
          '<p style="margin:0; font-size:19px; line-height:1.5; opacity:.8; max-width:32em">' + meta.blurb + '</p>' +
          '<button data-action="advance" style="border:0; cursor:pointer; background:' + (onDark ? PET : '#FBF8F3') + '; color:' + (onDark ? '#FBF8F3' : PET) + '; font-size:16px; font-weight:700; padding:17px 30px; border-radius:6px; align-self:flex-start; margin-top:8px">seguir con mis preguntas</button>' +
        '</div>' +
      '</div>';
  }

  function renderInter() {
    var s = state;
    var stageK = stageKey();
    var meta = STAGE_META[stageK];
    var accent = meta ? meta.color : PET;
    var onDark = stageK === 'explorando' || stageK === 'iniciando';
    var btnFg = onDark ? PET : '#fff';
    var step = steps()[s.bIdx];
    return '' +
      '<div style="min-height:100vh; background:#FBF8F3; display:flex; align-items:center; justify-content:center; padding:56px 24px">' +
        '<div style="width:100%; max-width:680px; display:flex; flex-direction:column; gap:26px" class="ndf-anim">' +
          '<div style="width:44px; height:4px; border-radius:99px; background:' + accent + '"></div>' +
          (step.kicker ? '<div style="font-size:12px; font-weight:700; letter-spacing:.14em; text-transform:uppercase; color:rgba(2,35,50,.5)">' + step.kicker + '</div>' : '') +
          '<p style="margin:0; font-size:32px; line-height:1.3; font-weight:600; letter-spacing:-.025em; text-wrap:pretty">' + step.quote + '</p>' +
          '<p style="margin:0; font-size:18px; line-height:1.55; color:rgba(2,35,50,.65)">' + step.note + '</p>' +
          (step.source ? '<div style="font-size:12px; color:rgba(2,35,50,.42)">' + step.source + '</div>' : '') +
          '<button data-action="advance" style="border:0; cursor:pointer; background:' + accent + '; color:' + btnFg + '; font-size:16px; font-weight:700; padding:17px 32px; border-radius:6px; align-self:flex-start">siguiente</button>' +
        '</div>' +
      '</div>';
  }

  function renderGate() {
    var s = state;
    var stageK = stageKey();
    var meta = STAGE_META[stageK];
    var accent = meta ? meta.color : PET;
    var onDark = stageK === 'explorando' || stageK === 'iniciando';
    var btnFg = onDark ? PET : '#fff';
    var valid = isGateValid();
    return '' +
      '<div style="min-height:100vh; background:#FBF8F3; display:flex; align-items:center; justify-content:center; padding:56px 24px">' +
        '<div style="width:100%; max-width:520px; display:flex; flex-direction:column; gap:22px" class="ndf-anim">' +
          '<div style="font-size:12px; font-weight:700; letter-spacing:.14em; text-transform:uppercase; color:rgba(2,35,50,.5)">último paso</div>' +
          '<h2 style="margin:0; font-size:36px; line-height:1.15; font-weight:700; letter-spacing:-.03em">tu diagnóstico está listo.</h2>' +
          '<p style="margin:0; font-size:17px; line-height:1.55; color:rgba(2,35,50,.65)">te mostraremos el diagnóstico en pantalla, te llegará al correo, y si quieres puedes descargarlo.</p>' +
          '<div style="display:flex; flex-direction:column; gap:10px">' +
            '<input id="gate-name" type="text" placeholder="tu nombre" value="' + s.name + '" style="width:100%; border:1.5px solid rgba(2,35,50,.16); background:#fff; border-radius:6px; padding:16px 16px; font-size:16px; color:#022332; outline:none">' +
            '<input id="gate-email" type="email" placeholder="tu correo" value="' + s.email + '" style="width:100%; border:1.5px solid rgba(2,35,50,.16); background:#fff; border-radius:6px; padding:16px 16px; font-size:16px; color:#022332; outline:none">' +
            '<input id="gate-whatsapp" type="tel" placeholder="tu whatsapp" value="' + s.whatsapp + '" style="width:100%; border:1.5px solid rgba(2,35,50,.16); background:#fff; border-radius:6px; padding:16px 16px; font-size:16px; color:#022332; outline:none">' +
          '</div>' +
          '<button id="gate-next-btn" data-action="advance" ' + (valid ? '' : 'disabled') + ' style="border:0; cursor:' + (valid ? 'pointer' : 'not-allowed') + '; background:' + accent + '; color:' + btnFg + '; font-size:16px; font-weight:700; padding:17px 32px; border-radius:6px; opacity:' + (valid ? '1' : '.35') + '; align-self:stretch; text-align:center">ver mi diagnóstico</button>' +
          '<div style="font-size:12px; line-height:1.5; color:rgba(2,35,50,.42)">nada de spam. te escribimos cuando tenemos algo que sirve.</div>' +
        '</div>' +
      '</div>';
  }

  // ---- Página de oferta (aparece para iniciando/caos/escalando, debajo del ----
  // ---- diagnóstico corto + recursos — mismo contenido para las 3 etapas) ----
  // Nota: todavía no está conectada al flujo de renderResult(); primero la revisamos
  // visualmente sola, después la integramos junto con el rediseño del video y la
  // ramificación por etapa.

  function offerImagePlaceholder(label, onDark) {
    var borderColor = onDark ? 'rgba(251,248,243,.3)' : 'rgba(2,35,50,.25)';
    var textColor = onDark ? 'rgba(251,248,243,.55)' : 'rgba(2,35,50,.4)';
    return '' +
      '<div style="width:100%; aspect-ratio:16/10; border-radius:10px; border:1.5px dashed ' + borderColor + '; display:flex; align-items:center; justify-content:center; padding:24px; text-align:center">' +
        '<div style="font-size:12px; font-weight:600; letter-spacing:.1em; text-transform:uppercase; color:' + textColor + '">' + label + '</div>' +
      '</div>';
  }

  function renderOfferSection(accent) {
    var accentText = accent === '#7ED957' ? '#4f9c31' : accent;

    var doundeEstasHtml = '' +
      '<div style="width:100%; max-width:680px; display:flex; flex-direction:column; gap:24px; padding:64px 24px">' +
        '<div style="font-size:12px; font-weight:700; letter-spacing:.14em; text-transform:uppercase; color:rgba(2,35,50,.5)">dónde estás hoy</div>' +
        '<p style="margin:0; font-size:20px; line-height:1.65; color:' + PET + '">si tuviera que adivinar: ya intentaste un excel, capaz revisas tu cuenta bancaria como termómetro, quizás hasta tienes contador — y aun así no sabes si el mes pasado ganaste o perdiste plata de verdad. vender no es lo mismo que ganar. no es que seas malo con los números: nadie te enseñó qué preguntarle a tu plata.</p>' +
      '</div>';

    var historiaHtml = '' +
      '<div style="width:100%; max-width:680px; display:flex; flex-direction:column; gap:24px; padding:0 24px 64px">' +
        '<div style="font-size:12px; font-weight:700; letter-spacing:.14em; text-transform:uppercase; color:rgba(2,35,50,.5)">la historia</div>' +
        '<p style="margin:0; font-size:20px; line-height:1.65; color:' + PET + '">hay una escena que veo repetirse tanto que ya la reconozco antes de que el fundador termine de contarla: alguien que factura bien, se ve exitoso desde afuera, y toma decisiones de plata a ciegas. jorge odeh me dio el dato: en retail el margen neto anda entre 6% y 18% — una empresa que se ve sana puede quedarse sin caja en un par de meses. en winehouse no lo supieron hasta que ordenaron su facturación: recién ahí supieron cuánto gastar, a quién contratar y cómo invertir.</p>' +
      '</div>';

    var secretoHtml = '' +
      '<div style="width:100%; max-width:820px; display:flex; flex-direction:column; gap:32px; padding:0 24px 64px">' +
        '<div style="display:flex; flex-direction:column; gap:14px">' +
          '<h3 style="margin:0; font-size:30px; font-weight:700; letter-spacing:-.02em; color:' + PET + '">tres preguntas, no un curso de contabilidad</h3>' +
        '</div>' +
        '<div style="display:grid; grid-template-columns:repeat(3, 1fr); gap:24px">' +
          '<div style="display:flex; flex-direction:column; gap:12px"><div style="font-size:13px; font-weight:700; letter-spacing:.08em; text-transform:uppercase; color:' + accentText + '">liquidez</div><div style="font-size:15px; line-height:1.5; color:rgba(2,35,50,.7)">¿cuánta plata tengo hoy, de verdad?</div></div>' +
          '<div style="display:flex; flex-direction:column; gap:12px"><div style="font-size:13px; font-weight:700; letter-spacing:.08em; text-transform:uppercase; color:' + accentText + '">margen</div><div style="font-size:15px; line-height:1.5; color:rgba(2,35,50,.7)">¿cuánto me queda por cada producto o canal?</div></div>' +
          '<div style="display:flex; flex-direction:column; gap:12px"><div style="font-size:13px; font-weight:700; letter-spacing:.08em; text-transform:uppercase; color:' + accentText + '">punto de equilibrio</div><div style="font-size:15px; line-height:1.5; color:rgba(2,35,50,.7)">¿cuánto necesito vender este mes para no perder plata?</div></div>' +
        '</div>' +
      '</div>';

    var proofHtml = '' +
      '<div style="width:100%; max-width:820px; display:flex; flex-direction:column; gap:28px; padding:0 24px 64px">' +
        '<div style="font-size:12px; font-weight:700; letter-spacing:.14em; text-transform:uppercase; color:rgba(2,35,50,.5)">de la comunidad</div>' +
        '<div style="display:grid; grid-template-columns:1.1fr .9fr; gap:32px; align-items:center">' +
          '<p style="margin:0; font-size:19px; line-height:1.65; color:' + PET + '">un miembro de la comunidad llegó justo después de que un influencer disparara la demanda de uno de sus productos de la noche a la mañana. la alegría le duró poco: se dio cuenta de que tenía más capital atado en inventario del que pensaba, y no sabía a quién priorizarle el despacho cuando el stock no le alcanzaba para todos los pedidos. armó su tablero, empezó a mirar sus números antes de decidir, y hoy no escala su publicidad ni prioriza un pedido sobre otro por instinto — lo hace mirando el número.</p>' +
          offerImagePlaceholder('espacio para imagen — testimonio de la comunidad') +
        '</div>' +
      '</div>';

    var bulletsHtml = [
      'acceso a todos los módulos grabados que tu ecommerce necesita para crecer — finanzas con oscar rincón, marketing, importaciones, ia, automatizaciones, y el resto.',
      'sesiones en vivo, cada semana, donde tú mismo expones tus avances y tus trabas frente a la comunidad.',
      'descuentos en las herramientas clave que ya usas o vas a necesitar, y premios reales por compartir lo que vas logrando.',
      'acceso a un catálogo completo de profesionales que ya trabajan con ecommerce chilenos, para asesoría puntual.',
      'tres sesiones de foco a la semana, con gente que ya va un paso adelante.',
      'grupo exclusivo de directorio (etapa avanzada), sesiones semanales sobre indicadores financieros con otros empresarios de tu nivel.',
      'grupo de whatsapp activo 24/7.',
      'diagnóstico 1:1 de bienvenida.',
      'encuentros presenciales cada mes — los come together night.'
    ].map(function (b) {
      return '' +
        '<div style="display:flex; gap:14px; align-items:flex-start">' +
          '<div style="flex:0 0 auto; width:8px; height:8px; border-radius:2px; background:' + accent + '; margin-top:9px"></div>' +
          '<div style="font-size:16px; line-height:1.55; color:rgba(251,248,243,.88)">' + b + '</div>' +
        '</div>';
    }).join('');

    var ofertaHtml = '' +
      '<div style="width:100%; background:' + PET + '; padding:72px 24px">' +
        '<div style="max-width:820px; margin:0 auto; display:flex; flex-direction:column; gap:36px">' +
          '<div style="display:flex; flex-direction:column; gap:12px">' +
            '<div style="font-size:12px; font-weight:700; letter-spacing:.14em; text-transform:uppercase; color:rgba(251,248,243,.55)">negocios del futuro</div>' +
            '<h3 style="margin:0; font-size:32px; line-height:1.2; font-weight:800; letter-spacing:-.02em; color:#FBF8F3">el módulo de finanzas es solo el punto de partida</h3>' +
          '</div>' +
          '<div style="display:flex; flex-direction:column; gap:18px">' + bulletsHtml + '</div>' +
          '<div style="max-width:420px; margin:0 auto; width:100%">' + offerImagePlaceholder('espacio para foto/mockup de la oferta', true) + '</div>' +
          '<button data-action="advance" style="align-self:center; border:0; cursor:pointer; background:' + accent + '; color:#022332; font-size:16px; font-weight:700; padding:18px 36px; border-radius:6px">quiero mi acceso — $570 usd/año</button>' +
        '</div>' +
      '</div>';

    var stackRows = [
      ['módulos grabados completos (12+ expertos, incl. finanzas)', '$497 usd'],
      ['sesiones en vivo de accountability semanales', '$297 usd'],
      ['sesiones de foco (3x semana)', '$397 usd'],
      ['grupo directorio (etapa avanzada)', '$297 usd'],
      ['come together night (mensual)', '$197 usd'],
      ['descuentos en herramientas + premios', '$97 usd'],
      ['descuentos en asesorías pagadas', '$147 usd'],
      ['grupo de whatsapp 24/7', '$147 usd'],
      ['diagnóstico 1:1 de bienvenida', '$97 usd']
    ].map(function (r) {
      return '' +
        '<div style="display:flex; justify-content:space-between; gap:16px; padding:14px 0; border-bottom:1px solid rgba(2,35,50,.1)">' +
          '<div style="font-size:15px; color:rgba(2,35,50,.75)">' + r[0] + '</div>' +
          '<div style="font-size:15px; font-weight:600; color:' + PET + '; white-space:nowrap">' + r[1] + '</div>' +
        '</div>';
    }).join('');

    var stackingHtml = '' +
      '<div style="width:100%; max-width:680px; display:flex; flex-direction:column; gap:8px; padding:72px 24px">' +
        '<div style="font-size:12px; font-weight:700; letter-spacing:.14em; text-transform:uppercase; color:rgba(2,35,50,.5); margin-bottom:8px">todo lo que incluye</div>' +
        stackRows +
        '<div style="display:flex; justify-content:space-between; gap:16px; padding:18px 0 8px; margin-top:8px; border-top:2px solid ' + PET + '">' +
          '<div style="font-size:16px; font-weight:700; color:' + PET + '">total valorado</div>' +
          '<div style="font-size:16px; font-weight:700; color:' + PET + '">$2.173 usd</div>' +
        '</div>' +
        '<div style="display:flex; justify-content:space-between; gap:16px; align-items:center; margin-top:6px; padding:18px 22px; border-radius:8px; background:' + tint(accent, .14) + '">' +
          '<div style="font-size:17px; font-weight:700; color:' + PET + '">precio real hoy</div>' +
          '<div style="display:flex; flex-direction:column; align-items:flex-end; gap:2px">' +
            '<div style="font-size:26px; font-weight:800; color:' + PET + '; line-height:1">$570 usd / año</div>' +
            '<div style="font-size:13px; font-weight:600; color:rgba(2,35,50,.55)">o $57 usd / mes</div>' +
          '</div>' +
        '</div>' +
      '</div>';

    var bonusHtml = '' +
      '<div style="width:100%; max-width:680px; display:flex; flex-direction:column; gap:18px; padding:0 24px 64px">' +
        '<div style="font-size:12px; font-weight:700; letter-spacing:.14em; text-transform:uppercase; color:rgba(2,35,50,.5)">bonus</div>' +
        '<p style="margin:0; font-size:18px; line-height:1.6; color:rgba(2,35,50,.75)">y si te inscribes ahora, te llevas de regalo el prompt para armar tu propio tablero de indicadores financieros directo en claude o chatgpt — le pegas tus números y te arma el tablero de liquidez, margen y punto de equilibrio en minutos.</p>' +
        '<div style="display:flex; justify-content:space-between; gap:16px; padding:14px 18px; border-radius:8px; border:1px solid rgba(2,35,50,.12)">' +
          '<div style="font-size:15px; color:rgba(2,35,50,.75)">prompt/skill tablero financiero</div>' +
          '<div style="font-size:15px; font-weight:600; color:' + PET + '">$67 usd</div>' +
        '</div>' +
      '</div>';

    var faqItems = [
      ['¿esto sirve si ya tengo contador?', 'sí, tu contador te da el balance para el sii; este tablero es para decidir, no para declarar impuestos.'],
      ['¿necesito saber de finanzas o excel avanzado?', 'no, las tres preguntas del tablero están pensadas para dueños de ecommerce.'],
      ['¿cuánto tiempo toma aplicarlo?', 'minutos por semana, una vez armado el tablero inicial.']
    ].map(function (f) {
      return '' +
        '<div style="display:flex; flex-direction:column; gap:8px; padding:20px 0; border-bottom:1px solid rgba(2,35,50,.1)">' +
          '<div style="font-size:17px; font-weight:700; color:' + PET + '">' + f[0] + '</div>' +
          '<div style="font-size:15px; line-height:1.55; color:rgba(2,35,50,.65)">' + f[1] + '</div>' +
        '</div>';
    }).join('');

    var faqHtml = '' +
      '<div style="width:100%; max-width:680px; display:flex; flex-direction:column; padding:0 24px 64px">' +
        '<div style="font-size:12px; font-weight:700; letter-spacing:.14em; text-transform:uppercase; color:rgba(2,35,50,.5); margin-bottom:8px">preguntas frecuentes</div>' +
        faqItems +
      '</div>';

    var ctaFinalHtml = '' +
      '<div style="width:100%; display:flex; justify-content:center; padding:0 24px 88px">' +
        '<button data-action="advance" style="border:0; cursor:pointer; background:' + accent + '; color:#022332; font-size:17px; font-weight:700; padding:19px 40px; border-radius:6px">quiero mi acceso — $570 usd/año</button>' +
      '</div>';

    return '' +
      '<div style="width:100%; background:#FBF8F3; display:flex; flex-direction:column; align-items:center">' +
        doundeEstasHtml + historiaHtml + secretoHtml + proofHtml +
      '</div>' +
      ofertaHtml +
      '<div style="width:100%; background:#FBF8F3; display:flex; flex-direction:column; align-items:center">' +
        stackingHtml + bonusHtml + faqHtml + ctaFinalHtml +
      '</div>';
  }

  function renderVslBlock(accent) {
    var hasVideo = !!VSL_VIDEO_URL;
    return '' +
      '<div class="no-print" style="display:flex; flex-direction:column; gap:14px">' +
        '<div style="font-size:12px; font-weight:700; letter-spacing:.14em; text-transform:uppercase; color:rgba(2,35,50,.5)">julián te explica tu resultado</div>' +
        '<div style="position:relative; width:100%; aspect-ratio:16/9; background:#022332; border-radius:10px; overflow:hidden">' +
          (hasVideo ?
            '<video id="vsl-video" src="' + VSL_VIDEO_URL + '" playsinline preload="auto" disablepictureinpicture tabindex="-1" oncontextmenu="return false" style="width:100%; height:100%; object-fit:cover; display:block; background:#022332"></video>'
            :
            '<div style="position:absolute; inset:0; display:flex; flex-direction:column; align-items:center; justify-content:center; gap:10px; color:rgba(251,248,243,.5); font-size:13px; text-align:center; padding:0 24px">' +
              '<div style="width:64px; height:64px; border-radius:99px; border:1.5px solid rgba(251,248,243,.35); display:flex; align-items:center; justify-content:center"><div style="width:0; height:0; border-left:16px solid rgba(251,248,243,.7); border-top:10px solid transparent; border-bottom:10px solid transparent; margin-left:4px"></div></div>' +
              '<div>espacio para el video de julián — pega la URL en VSL_VIDEO_URL</div>' +
            '</div>'
          ) +
          '<div id="vsl-sound-overlay" style="display:none; position:absolute; inset:0; align-items:center; justify-content:center; background:rgba(2,35,50,.55)">' +
            '<button data-action="vsl-activar-sonido" style="border:0; cursor:pointer; background:#FBF8F3; color:#022332; font-size:15px; font-weight:700; padding:14px 26px; border-radius:6px">activar sonido</button>' +
          '</div>' +
          '<div style="position:absolute; left:0; right:0; bottom:0; display:flex; align-items:center; gap:12px; padding:10px 14px; background:linear-gradient(to top, rgba(2,35,50,.85), rgba(2,35,50,0))">' +
            '<div id="vsl-elapsed" style="font-variant-numeric:tabular-nums; font-size:12px; font-weight:600; color:#FBF8F3">0:00</div>' +
            '<div style="flex:1; height:3px; border-radius:99px; background:rgba(251,248,243,.25); overflow:hidden"><div id="vsl-fill" style="height:100%; width:0%; background:' + accent + '"></div></div>' +
            '<div id="vsl-remaining" style="font-variant-numeric:tabular-nums; font-size:12px; font-weight:600; color:#FBF8F3">' + VSL_FALLBACK_DURATION + '</div>' +
            (hasVideo ? '<button id="vsl-mute-btn" data-action="vsl-toggle-mute" style="border:1px solid rgba(251,248,243,.4); background:none; cursor:pointer; color:#FBF8F3; font-size:11px; font-weight:600; padding:6px 10px; border-radius:99px; white-space:nowrap">silenciar</button>' : '') +
          '</div>' +
        '</div>' +
        '<div id="locked-notice" style="display:flex; align-items:center; gap:10px">' +
          '<span style="width:8px; height:8px; border-radius:99px; background:' + accent + '; display:inline-block; animation:ndfPulse 1.1s ease-in-out infinite"></span>' +
          '<div style="font-size:14px; color:rgba(2,35,50,.6)">armando tu diagnóstico…</div>' +
        '</div>' +
      '</div>';
  }

  function renderDiagResourcesBlock(stageK, accent, topBorder) {
    var diag = (DIAG[stageK] || DIAG.iniciando)[tierKeyForState()];
    var videos = (VIDEOS[stageK] || VIDEOS.iniciando).map(function (v) {
      return { min: v.min, title: v.title, quote: v.quote, thumbUrl: 'https://img.youtube.com/vi/' + v.id + '/hqdefault.jpg', url: 'https://youtu.be/' + v.id + '?t=' + v.t };
    });
    var videosHtml = videos.map(function (v) {
      return '' +
        '<a href="' + v.url + '" target="_blank" rel="noopener" class="video-card no-print" style="display:flex; flex-direction:column; gap:12px; background:#fff; border:1px solid rgba(2,35,50,.1); border-radius:10px; overflow:hidden; text-decoration:none; color:#022332">' +
          '<div style="width:100%; aspect-ratio:16/9; background:#022332 center/cover no-repeat url(' + v.thumbUrl + ')"></div>' +
          '<div style="display:flex; flex-direction:column; gap:8px; padding:0 16px 18px">' +
            '<div style="font-size:11px; font-weight:700; letter-spacing:.1em; text-transform:uppercase; color:' + (accent === '#7ED957' ? '#4f9c31' : accent) + '">min. ' + v.min + '</div>' +
            '<div style="font-size:15px; font-weight:700; line-height:1.3">' + v.title + '</div>' +
            '<div style="font-size:13px; line-height:1.5; color:rgba(2,35,50,.65)">' + v.quote + '</div>' +
            '<div style="font-size:12px; font-weight:600; color:rgba(2,35,50,.45)">ver al minuto exacto →</div>' +
          '</div>' +
        '</a>';
    }).join('');

    return '' +
      '<div style="display:flex; flex-direction:column; gap:16px;' + (topBorder ? ' border-top:1px solid rgba(2,35,50,.12); padding-top:36px' : '') + '">' +
        '<div style="font-size:12px; font-weight:700; letter-spacing:.14em; text-transform:uppercase; color:rgba(2,35,50,.5)">tu diagnóstico</div>' +
        '<p style="margin:0; font-size:20px; line-height:1.55; font-weight:500">' + diag[0] + '</p>' +
        '<p style="margin:0; font-size:18px; line-height:1.6; color:rgba(2,35,50,.72)">' + diag[1] + '</p>' +
      '</div>' +
      '<div style="display:flex; flex-direction:column; gap:18px">' +
        '<div style="font-size:12px; font-weight:700; letter-spacing:.14em; text-transform:uppercase; color:rgba(2,35,50,.5)">recursos para ti</div>' +
        '<div style="display:grid; grid-template-columns:repeat(3, 1fr); gap:18px">' + videosHtml + '</div>' +
      '</div>' +
      '<div class="no-print" style="display:flex; flex-direction:column; gap:12px; align-items:flex-start">' +
        '<div style="display:flex; gap:12px; flex-wrap:wrap">' +
          '<button data-action="download-pdf" class="btn-outline" style="border:1.5px solid rgba(2,35,50,.2); background:none; cursor:pointer; font-size:15px; font-weight:600; color:#022332; padding:15px 26px; border-radius:6px">descargar mi diagnóstico en pdf</button>' +
          '<button id="send-email-btn" data-action="send-email" class="btn-outline" style="border:1.5px solid rgba(2,35,50,.2); background:none; cursor:pointer; font-size:15px; font-weight:600; color:#022332; padding:15px 26px; border-radius:6px">enviar a mi correo</button>' +
        '</div>' +
        '<button data-action="restart" class="btn-link-muted" style="border:0; background:none; cursor:pointer; font-size:13px; font-weight:600; color:rgba(2,35,50,.4); padding:0">volver a empezar</button>' +
      '</div>';
  }

  function renderExploringSoftCta(accent) {
    return '' +
      '<div class="no-print" style="background:' + PET + '; color:#FBF8F3; border-radius:12px; padding:40px; display:flex; flex-direction:column; gap:22px">' +
        '<div style="display:flex; flex-direction:column; gap:10px">' +
          '<h3 style="margin:0; font-size:28px; line-height:1.2; font-weight:700; letter-spacing:-.025em">todavía no necesitas pagar nada.</h3>' +
          '<p style="margin:0; font-size:16px; line-height:1.55; color:rgba(251,248,243,.7)">en tu etapa lo que más rinde es criterio, no un curso. escucha a gente que ya pasó por donde estás tú.</p>' +
        '</div>' +
        '<div style="display:flex; gap:12px; flex-wrap:wrap">' +
          '<button style="border:0; cursor:pointer; background:' + accent + '; color:#022332; font-size:15px; font-weight:700; padding:16px 26px; border-radius:6px">sigue el podcast de negocios del futuro</button>' +
        '</div>' +
      '</div>';
  }

  function tierKeyForState() {
    var total = state.scores.reduce(function (a, b) { return a + b; }, 0);
    var maxScore = Math.max(1, questionSteps().length * 3);
    return tierKey(Math.round(total / maxScore * 100));
  }

  function renderResult() {
    var s = state;
    var stageK = stageKey();
    var meta = STAGE_META[stageK];
    var accent = meta.color;
    var isExpl = stageK === 'explorando';

    var total = s.scores.reduce(function (a, b) { return a + b; }, 0);
    var maxScore = Math.max(1, questionSteps().length * 3);
    var pct = Math.round((total / maxScore) * 100);
    var tierK = tierKey(pct);
    var tier = TIERS[tierK];
    var titles = { rojo: 'estás en riesgo alto con la plata de tu negocio.', amarillo: 'vas bien, pero hay brechas críticas.', verde: 'tienes bases sólidas. ahora hay que subir el techo.' };
    var markerPct = Math.min(96, Math.max(4, pct));
    var tierPillFg = (tierK === 'amarillo' || tierK === 'verde') ? PET : '#fff';

    var headerHtml = '' +
      '<div style="display:flex; flex-direction:column; gap:18px">' +
        '<div style="display:flex; align-items:center; gap:12px; flex-wrap:wrap">' +
          '<span style="background:' + tier.color + '; color:' + tierPillFg + '; font-size:12px; font-weight:700; letter-spacing:.08em; text-transform:uppercase; padding:8px 14px; border-radius:99px">' + tier.label + '</span>' +
          '<span style="border:1.5px solid ' + accent + '; color:' + PET + '; font-size:12px; font-weight:600; padding:7px 13px; border-radius:99px">etapa: ' + meta.name + '</span>' +
        '</div>' +
        '<h1 style="margin:0; font-size:46px; line-height:1.1; font-weight:800; letter-spacing:-.035em; text-wrap:balance">' + titles[tierK] + '</h1>' +
      '</div>' +
      '<div style="display:flex; flex-direction:column; gap:14px">' +
        '<div style="position:relative; padding-top:58px">' +
          '<div style="position:absolute; top:0; left:' + markerPct + '%; transform:translateX(-50%); display:flex; flex-direction:column; align-items:center">' +
            '<svg width="58" height="58" viewBox="0 0 24 24" fill="none"><path d="M12 1.8c-4.1 0-7.4 3.3-7.4 7.4 0 5.3 6.4 12.1 6.7 12.4a1 1 0 0 0 1.4 0c.3-.3 6.7-7.1 6.7-12.4 0-4.1-3.3-7.4-7.4-7.4Z" fill="#022332"></path><circle cx="12" cy="9.1" r="2.9" fill="#FBF8F3"></circle></svg>' +
          '</div>' +
          '<div style="display:flex; height:14px; border-radius:99px; overflow:hidden"><div style="flex:34; background:#e7392f"></div><div style="flex:38; background:#E8B62C"></div><div style="flex:28; background:#7ED957"></div></div>' +
        '</div>' +
        '<div style="display:flex; justify-content:space-between; font-size:12px; font-weight:600; color:rgba(2,35,50,.5)"><span>riesgo alto</span><span>brechas críticas</span><span>bases sólidas</span></div>' +
      '</div>';

    var bodyHtml;
    if (isExpl) {
      // Explorando: sin video, sin página de oferta — directo del semáforo al
      // diagnóstico corto + recursos, más una invitación suave (contenido gratis).
      bodyHtml = '' +
        '<div style="display:flex; flex-direction:column; gap:44px" class="ndf-anim">' +
          renderDiagResourcesBlock(stageK, accent, true) +
          renderExploringSoftCta(accent) +
        '</div>';
    } else {
      bodyHtml = '' +
        renderVslBlock(accent) +
        '<div id="unlocked-wrap" style="display:' + (s.unlocked ? 'flex' : 'none') + '; flex-direction:column; gap:44px" class="ndf-anim">' +
          renderDiagResourcesBlock(stageK, accent, true) +
          // La página de oferta se diseñó como sección de ancho completo (la franja
          // oscura "la oferta" ocupa todo el viewport). Este wrapper la saca del
          // contenedor de 820px sin tocar renderOfferSection() en sí.
          '<div style="width:100vw; margin-left:calc(50% - 50vw); margin-right:calc(50% - 50vw)">' + renderOfferSection(accent) + '</div>' +
        '</div>';
    }

    return '' +
      '<div style="min-height:100vh; background:#FBF8F3; display:flex; flex-direction:column; align-items:center; padding:48px 24px 96px">' +
        '<div style="width:100%; max-width:820px; display:flex; flex-direction:column; gap:44px">' +
          headerHtml +
          bodyHtml +
        '</div>' +
      '</div>';
  }

  function renderScreen() {
    var s = state;
    if (s.screen === 'landing') return renderLanding();
    if (s.screen === 'notice') return renderNotice();
    if (s.screen === 'seg') return renderQuestion();
    if (s.screen === 'reveal') return renderReveal();
    if (s.screen === 'block') {
      var step = steps()[s.bIdx];
      return step.type === 'q' ? renderQuestion() : renderInter();
    }
    if (s.screen === 'gate') return renderGate();
    if (s.screen === 'result') return renderResult();
    return '';
  }

  var gatePollTimer = null;

  function render() {
    var root = document.getElementById('ndf-test-root');
    if (root) root.innerHTML = renderScreen();
    if (state.screen === 'gate') { startGatePoll(); } else { stopGatePoll(); }
  }

  // ---- eventos (delegación, se conecta una sola vez) ----

  function onRootClick(e) {
    var el = e.target.closest('[data-action]');
    if (!el) return;
    var action = el.getAttribute('data-action');
    if (action === 'advance') return advance();
    if (action === 'back') return goBack();
    if (action === 'restart') return restart();
    if (action === 'pick-seg' || action === 'pick-block') {
      state.sel = parseInt(el.getAttribute('data-idx'), 10);
      render();
      return;
    }
    if (action === 'vsl-activar-sonido') return activarSonidoVsl();
    if (action === 'vsl-toggle-mute') return toggleVslMute();
    if (action === 'download-pdf') return window.print();
    if (action === 'send-email') return handleSendEmailClick(el);
  }

  // Botón "enviar a mi correo": el diagnóstico ya se registra en Klaviyo automáticamente
  // al terminar el test (sendDiagnosisEmail() en el paso del gate) — este botón es para
  // reenviarlo manualmente si la persona lo pide, con su propio estado de carga/éxito.
  function handleSendEmailClick(btn) {
    if (btn.getAttribute('data-sending') === '1') return;
    btn.setAttribute('data-sending', '1');
    var original = btn.textContent;
    btn.textContent = 'enviando…';
    sendDiagnosisEmail();
    setTimeout(function () {
      btn.textContent = '¡enviado! revisa tu correo.';
      setTimeout(function () {
        btn.textContent = original;
        btn.removeAttribute('data-sending');
      }, 2600);
    }, 700);
  }

  function onRootInput(e) {
    var el = e.target;
    if (el.id === 'gate-name') { state.name = el.value; return; }
    if (el.id === 'gate-email') {
      state.email = el.value;
      updateGateButton();
      return;
    }
    if (el.id === 'gate-whatsapp') {
      state.whatsapp = el.value;
      updateGateButton();
      return;
    }
  }

  function updateGateButton() {
    var valid = isGateValid();
    var nextBtn = document.getElementById('gate-next-btn');
    if (!nextBtn) return;
    nextBtn.disabled = !valid;
    nextBtn.style.opacity = valid ? '1' : '.35';
    nextBtn.style.cursor = valid ? 'pointer' : 'not-allowed';
  }

  // El autocompletado del navegador (o de un gestor de contraseñas) a veces no dispara
  // el evento "input" normal. Este chequeo periódico, mientras estás en la pantalla del
  // correo, lee el valor real del campo directo del DOM y sincroniza el botón, sin
  // depender de que el evento se dispare.
  function startGatePoll() {
    clearInterval(gatePollTimer);
    gatePollTimer = setInterval(function () {
      var emailEl = document.getElementById('gate-email');
      var nameEl = document.getElementById('gate-name');
      var waEl = document.getElementById('gate-whatsapp');
      if (!emailEl) { clearInterval(gatePollTimer); return; }
      if (emailEl.value !== state.email) state.email = emailEl.value;
      if (nameEl && nameEl.value !== state.name) state.name = nameEl.value;
      if (waEl && waEl.value !== state.whatsapp) state.whatsapp = waEl.value;
      updateGateButton();
    }, 350);
  }

  function stopGatePoll() {
    clearInterval(gatePollTimer);
    gatePollTimer = null;
  }

  // Estilos que este archivo necesita y que no dependen del tema (el pulso del
  // indicador "armando tu diagnóstico…" y qué ocultar al usar el botón de PDF, que
  // usa el diálogo de impresión nativo del navegador — ahí la persona elige "guardar
  // como PDF"). Se inyectan una sola vez, no dependen de un CSS aparte en el tema.
  function injectStyles() {
    if (document.getElementById('ndf-test-inline-styles')) return;
    var style = document.createElement('style');
    style.id = 'ndf-test-inline-styles';
    style.textContent = '' +
      '@keyframes ndfPulse { 0%, 100% { opacity: .3; transform: scale(.85); } 50% { opacity: 1; transform: scale(1); } }' +
      '@media print { .no-print { display: none !important; } }';
    document.head.appendChild(style);
  }

  function init() {
    var root = document.getElementById('ndf-test-root');
    if (!root) return;
    injectStyles();
    // Escuchamos desde document, no desde #ndf-test-root: si algún script del tema
    // reconstruye o clona ese contenedor (algunos temas lo hacen al reinicializar
    // formularios del carrito tras cambios en el DOM), un listener puesto en el propio
    // contenedor se pierde. document nunca se reemplaza, así que esto es a prueba de eso.
    document.addEventListener('click', onRootClick);
    document.addEventListener('input', onRootInput);
    document.addEventListener('change', onRootInput);
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();